module.exports = __webpack_public_path__ + "static/media/aycm.5b96ed13.jpg";